/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {FC} from 'react';
import {Text, View} from 'react-native';
import {formsStyles} from '../formStyles';

interface Props {
  label?: string;
  required?: boolean;
}

export const TitleLabel: FC<Props> = ({label = '', required = false}) => {
  return (
    <View>
      {label ? (
        <Text style={[formsStyles.labelStyle]}>
          {label} {required ? <Text>*</Text> : null} :
        </Text>
      ) : null}
    </View>
  );
};
